import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import {
  People,
  FileEarmarkText,
  ClipboardCheck,
  Award
} from 'react-bootstrap-icons';
import adminImage from '../../assets/img/logo.png';
import './AdminHomepage.css';

const AdminHomepage = () => {
  const navigate = useNavigate();

  const cards = [
    { title: 'Proveedores', icon: <People size={32} />, route: '/administrador/proveedores' },
    { title: 'Formularios', icon: <FileEarmarkText size={32} />, route: '/administrador/formularios' },
    { title: 'Evaluar', icon: <ClipboardCheck size={32} />, route: '/administrador/evaluacion' },
    { title: 'Calificar', icon: <Award size={32} />, route: '/administrador/calificacion' }
  ];

  return (
    <Container style={{ border: 'none' }}>
      <div className="header-section">
        <h1 className="fw-bold" style={{color: '#10417C'}}>Panel de Administrador</h1>
        <hr className="divider" />
      </div>

      <div className="text-center my-4">
        <img
          src={adminImage}
          alt="Panel de administración"
          className="img-fluid mb-3"
          style={{ width: "100%", maxWidth: 300 }}
        />
        <p className="text-muted">Bienvenido al sistema de administración</p>
      </div>

      <Row className="g-4 justify-content-center mt-4">
        {cards.map((c, idx) => (
          <Col key={idx} xs={12} sm={6} md={6} lg={3}>
            <Card className="admin-card h-100 text-center" onClick={() => navigate(c.route)}>
              <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4">
                <div className="icon-wrapper mb-3">{c.icon}</div>
                <Card.Title className="fw-semibold mb-0">{c.title}</Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AdminHomepage;